import { render } from "./ConfigText.vue?vue&type=template&id=5bfdda78&scoped=true"
import script from "./ConfigText.vue?vue&type=script&lang=js"
export * from "./ConfigText.vue?vue&type=script&lang=js"

import "./ConfigText.vue?vue&type=style&index=0&id=5bfdda78&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5bfdda78"]])

export default __exports__